import type { TriageItem, StaffMember, Course } from "./SafetySupportScreen";

// Staff list - matches users from Settings > Content Safety
export const mockStaff: StaffMember[] = [
  { id: "user-1", name: "Dr. Sarah Chen", email: "schen@university.edu", role: "Dean of Students" },
  { id: "user-2", name: "Marcus Williams", email: "mwilliams@university.edu", role: "Student Safety Officer" },
  { id: "user-3", name: "Dr. Emily Rodriguez", email: "erodriguez@university.edu", role: "Counseling Director" },
  { id: "user-4", name: "James Thompson", email: "jthompson@university.edu", role: "Title IX Coordinator" },
  { id: "user-5", name: "Dr. Aisha Patel", email: "apatel@university.edu", role: "VP Student Affairs" },
];

export const mockCourses: Course[] = [
  { id: "BIO-101", name: "Introduction to Biology" },
  { id: "BIO-201", name: "Cell Biology" },
  { id: "BIO-350", name: "Genetics" },
  { id: "CHEM-101", name: "General Chemistry" },
];

// Faculty courses (for filtering in faculty view)
export const facultyCourses = ["BIO-101", "BIO-201", "BIO-350"];

export const mockTriageItems: TriageItem[] = [
  {
    id: "TRG-001",
    type: "safety-alert",
    severity: "critical",
    category: "self-harm",
    studentId: "STU-2198",
    studentName: "Jordan Martinez",
    studentEmail: "j.martinez@university.edu",
    courseId: "BIO-101",
    courseName: "Introduction to Biology",
    excerpt: "Student expressed feelings of hopelessness and mentioned struggling to find reasons to continue...",
    fullContent:
      "During a conversation about exam stress, the student mentioned feeling overwhelmed and expressed thoughts about not wanting to continue. The AI detected potential self-harm indicators and flagged this conversation for review. The student has been struggling with the midterm material and expressed feeling like a failure.",
    createdAt: new Date("2026-01-12T08:30:00"),
    status: "open",
    assignedTo: null,
    activityLog: [
      {
        id: "evt-001",
        type: "flag-created",
        actor: "AI Safety System",
        timestamp: new Date("2026-01-12T08:30:00"),
        details: {},
      },
    ],
  },
  {
    id: "TRG-002",
    type: "safety-alert",
    severity: "high",
    category: "harassment",
    studentId: "STU-3421",
    studentName: "Priya Sharma",
    studentEmail: "p.sharma@university.edu",
    courseId: "BIO-201",
    courseName: "Cell Biology",
    excerpt: "Student reported experiencing harassment from a classmate during lab sessions...",
    fullContent:
      "The student disclosed to the AI that another student has been making inappropriate comments during lab sessions. The behavior has been ongoing for several weeks and is affecting their ability to focus on coursework. The student is hesitant to report formally but wanted to document the incidents.",
    createdAt: new Date("2026-01-11T14:22:00"),
    status: "in-progress",
    assignedTo: "James Thompson",
    activityLog: [
      {
        id: "evt-002a",
        type: "flag-created",
        actor: "AI Safety System",
        timestamp: new Date("2026-01-11T14:22:00"),
        details: {},
      },
      {
        id: "evt-002b",
        type: "assigned",
        actor: "Dr. Sarah Chen",
        timestamp: new Date("2026-01-11T15:30:00"),
        details: { assignedTo: "James Thompson" },
      },
      {
        id: "evt-002c",
        type: "note-added",
        actor: "James Thompson",
        timestamp: new Date("2026-01-11T16:00:00"),
        details: { content: "Escalated per Title IX policy. Will follow up with student next week." },
      },
    ],
    escalatedTo: "James Thompson",
  },
  {
    id: "TRG-003",
    type: "support-request",
    severity: "low",
    category: "extension-request",
    studentId: "STU-1842",
    studentName: "Emma Rodriguez",
    studentEmail: "e.rodriguez@university.edu",
    courseId: "BIO-201",
    courseName: "Cell Biology",
    excerpt: "Requesting extension for Lab Report 3 due to family emergency...",
    fullContent:
      "Student submitted a request for a 5-day extension on Lab Report 3. They mentioned a family emergency that required them to travel home unexpectedly. They have documentation available if needed and have maintained good standing in the course.",
    createdAt: new Date("2026-01-11T10:15:00"),
    status: "in-progress",
    assignedTo: "Dr. Sarah Chen",
    activityLog: [
      {
        id: "evt-003a",
        type: "flag-created",
        actor: "Student Request",
        timestamp: new Date("2026-01-11T10:15:00"),
        details: {},
      },
      {
        id: "evt-003b",
        type: "assigned",
        actor: "System",
        timestamp: new Date("2026-01-11T10:15:00"),
        details: { assignedTo: "Dr. Sarah Chen" },
      },
      {
        id: "evt-003c",
        type: "message-sent",
        actor: "Dr. Sarah Chen",
        timestamp: new Date("2026-01-11T11:00:00"),
        details: { subject: "Re: Extension Request for Lab Report 3", recipients: [] },
      },
      {
        id: "evt-003d",
        type: "note-added",
        actor: "Dr. Sarah Chen",
        timestamp: new Date("2026-01-11T11:30:00"),
        details: { content: "Approved 5-day extension. Student will submit by Jan 17." },
      },
    ],
  },
  {
    id: "TRG-004",
    type: "safety-alert",
    severity: "medium",
    category: "hate",
    studentId: "STU-4521",
    studentName: "David Park",
    studentEmail: "d.park@university.edu",
    courseId: "BIO-350",
    courseName: "Genetics",
    excerpt: "AI detected potentially discriminatory language in student conversation...",
    fullContent:
      "During a discussion about genetic diversity, the student made comments that the AI flagged as potentially discriminatory. Review needed to determine if educational intervention is appropriate.",
    createdAt: new Date("2026-01-10T09:45:00"),
    status: "open",
    assignedTo: null,
    activityLog: [
      {
        id: "evt-004",
        type: "flag-created",
        actor: "AI Safety System",
        timestamp: new Date("2026-01-10T09:45:00"),
        details: {},
      },
    ],
  },
  {
    id: "TRG-005",
    type: "support-request",
    severity: "low",
    category: "technical-issue",
    studentId: "STU-2876",
    studentName: "Marcus Chen",
    studentEmail: "m.chen@university.edu",
    courseId: "BIO-101",
    courseName: "Introduction to Biology",
    excerpt: "Unable to access quiz module - getting error message...",
    fullContent:
      'Student reports receiving an error when trying to access Quiz 4 in the Biology module. They have tried multiple browsers and devices. Screenshot attached shows "Access Denied" error.',
    createdAt: new Date("2026-01-10T16:30:00"),
    status: "resolved",
    assignedTo: "Marcus Williams",
    activityLog: [
      {
        id: "evt-005a",
        type: "flag-created",
        actor: "Student Request",
        timestamp: new Date("2026-01-10T16:30:00"),
        details: {},
      },
      {
        id: "evt-005b",
        type: "assigned",
        actor: "Dr. Sarah Chen",
        timestamp: new Date("2026-01-10T16:45:00"),
        details: { assignedTo: "Marcus Williams" },
      },
      {
        id: "evt-005c",
        type: "note-added",
        actor: "Marcus Williams",
        timestamp: new Date("2026-01-10T17:15:00"),
        details: { content: "Issue resolved - student was not properly enrolled in quiz group. Fixed permissions." },
      },
      {
        id: "evt-005d",
        type: "status-changed",
        actor: "Marcus Williams",
        timestamp: new Date("2026-01-10T17:16:00"),
        details: { fromStatus: "in-progress", toStatus: "Resolved" },
      },
    ],
  },
  {
    id: "TRG-006",
    type: "support-request",
    severity: "low",
    category: "question",
    studentId: "STU-3102",
    studentName: "Aisha Johnson",
    studentEmail: "a.johnson@university.edu",
    courseId: "CHEM-101",
    courseName: "General Chemistry",
    excerpt: "Question about final exam format and allowed materials...",
    fullContent:
      "Student is asking for clarification about what materials will be allowed during the final exam. They want to know if calculators are permitted and if a formula sheet will be provided.",
    createdAt: new Date("2026-01-09T11:20:00"),
    status: "open",
    assignedTo: null,
    activityLog: [
      {
        id: "evt-006",
        type: "flag-created",
        actor: "Student Request",
        timestamp: new Date("2026-01-09T11:20:00"),
        details: {},
      },
    ],
  },
  {
    id: "TRG-007",
    type: "safety-alert",
    severity: "critical",
    category: "self-harm/intent",
    studentId: "STU-5678",
    studentName: "Tyler Williams",
    studentEmail: "t.williams@university.edu",
    courseId: "BIO-201",
    courseName: "Cell Biology",
    excerpt: "Student expressed specific intent regarding self-harm during conversation...",
    fullContent:
      "AI detected high-confidence self-harm intent indicators. Student mentioned specific plans and timeline. Immediate wellness check recommended. Counseling Director has been automatically notified.",
    createdAt: new Date("2026-01-12T06:15:00"),
    status: "escalated",
    assignedTo: "Dr. Emily Rodriguez",
    activityLog: [
      {
        id: "evt-007a",
        type: "flag-created",
        actor: "AI Safety System",
        timestamp: new Date("2026-01-12T06:15:00"),
        details: {},
      },
      {
        id: "evt-007b",
        type: "assigned",
        actor: "System",
        timestamp: new Date("2026-01-12T06:15:00"),
        details: { assignedTo: "Dr. Emily Rodriguez" },
      },
      {
        id: "evt-007c",
        type: "status-changed",
        actor: "System",
        timestamp: new Date("2026-01-12T06:15:00"),
        details: { fromStatus: "open", toStatus: "Escalated" },
      },
      {
        id: "evt-007d",
        type: "note-added",
        actor: "System",
        timestamp: new Date("2026-01-12T06:15:00"),
        details: {
          content: "Auto-escalated to Dr. Emily Rodriguez (Counseling Director) due to critical self-harm indicators.",
        },
      },
      {
        id: "evt-007e",
        type: "note-added",
        actor: "Dr. Emily Rodriguez",
        timestamp: new Date("2026-01-12T07:00:00"),
        details: {
          content: "Crisis counselor dispatched. Student contacted and safe. Follow-up scheduled for tomorrow.",
        },
      },
    ],
    escalatedTo: "Dr. Emily Rodriguez",
  },
];
